<template>
	<div class="login-panel col xs-12 sm-12 md-6">
		<div v-if="!showRestForm" @keyup.enter="login">
			<div class="login-panel__title">Sign In</div>
			<div class="login-panel__subhead">Access your previous quotes and surveys by signing in.</div>
			
			<div class="form">
				<input type="email" v-model="email" placeholder="Email Address">
				<input type="password" v-model="password" placeholder="Password">
				<button class="btn primary login" @click="login">Login Securely </button>							
			</div>
			<p>Forgotten your password? Reset it <a @click="showRestForm = !showRestForm" href="#">here</a></p>
		</div>
		<div v-else>
			<div class="login-panel__title">Create password</div>	
			<div class="login-panel__subhead">To create a password, please enter your email address and then wait for an email.</div>
			<div class="form ma-form">
				<input type="email" v-model="resetEmail" placeholder="Email Address">
				<button class="btn primary" @click="resetPassword">Send email</button>
			</div>
			<p>Go to <a href="#" @click="showRestForm = !showRestForm">Login</a></p>
			
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			showRestForm : true,
			resetEmail : "",
			email : "",
			password : ""
		}
	},
	components : {
	

	},
	computed : {
	
	},
	methods : {

		login(){

			if(this.email.length == 0){

				this.$toasted.error('Please enter a user email', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                })
                return
			}

			if(this.password.length == 0){
				this.$toasted.error('Please enter a password', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                })
                return
			}

			this.$toasted.show('loggin in...', {
				theme: 'bubble',
                position: 'bottom-center',
				duration: null
            })

			this.$store.dispatch('userLogin', {email : this.email, password : this.password})
			.then((response) => {
				this.$toasted.clear();
				if(response.confirmation != 'success'){
					this.$toasted.error(response.message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                	})
				}

				this.$toasted.success("Welcome", {
                    theme: 'bubble',
                    position: 'bottom-center',
                    duration: 5000
               	})
			})
			.catch((err) => {
				this.$toasted.clear();
				this.$toasted.error(err.message, {
                    theme: 'bubble',
                    position: 'bottom-center',
                    duration: 5000
                })
				
			})
		},
		resetPassword(){
			if(this.resetEmail.length == 0){

				this.$toasted.error('Please enter a user email', {
	                theme: 'bubble',
	                position: 'bottom-center',
	                duration: 5000
	            })
	            return
			}
			this.$toasted.show('Please wait...', {
				theme: 'bubble',
	            position: 'bottom-center',
				duration: null
	        })

			this.$store.dispatch('userResetPassword', {email : this.resetEmail})
			.then((response) => {
				this.$toasted.clear();
				if(response.confirmation == 'validation'){
					this.$toasted.error(response.message, {
						theme: 'bubble',
			            position: 'bottom-center',
						duration: 5000
			        })
				} else {
					this.$toasted.success(response.message, {
						theme: 'bubble',
			            position: 'bottom-center',
						duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.error(err.message, {
					theme: 'bubble',
		            position: 'bottom-center',
					duration: 5000
		        })
			})

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/Login/MACreatePassword.vue